"use client";

import { useEffect } from "react";

export function YandexMapsScript({ lang }: { lang: string }) {
  useEffect(() => {
    const load = async () => {
      // При обычном подключении скрипт карт не переподключается, при смене языка в чекауте не правильно искался адрес.
      if ((window as any).ymaps) {
        delete (window as any).ymaps;
      }

      const old = document.querySelector("script[data-yandex-maps]");
      if (old) old.remove();

      await new Promise<void>((resolve, reject) => {
        const script = document.createElement("script");
        script.src = `https://api-maps.yandex.ru/2.1/?lang=${lang}&apikey=32ab2d9c-8897-4d17-9d78-eb8a53ffa515`;
        script.async = true;
        script.setAttribute("data-yandex-maps", "true");

        script.onload = () => resolve();
        script.onerror = () => reject();

        document.head.appendChild(script);
      });
    };

    load();
  }, [ lang ]);

  return null;
}
